import React, { useEffect } from "react";
import { Box, Grid, Typography, Button } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import BusinessPipelineTable from "components/BusinessPipelineTable";
import { BusinessPipelineMock } from "mockdata/BusinessPipelineMock"

const BusinessSummary = () => {
  const { projectId } = useParams();
  const navigate = useNavigate();
  const showPipeline = true;

  return (
    <>
      <Grid container spacing={2} sx={{ bgcolor: "#fff" }}>
        <Grid size={12} sx={{ p: 2, display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
          <Box>
            <Typography variant="h5" sx={{ fontSize: "36px", fontWeight: 700, color: "#252525" }}>
              Business Summary
            </Typography>
            <Typography sx={{ fontSize: "14px", fontWeight: 400, mt: "6px", fontFamily: "Outfit, sans-serif" }}>
              Executive snapshot delivering critical project health insights for strategic decision-making.
            </Typography>
          </Box>
        </Grid>
      </Grid>

      <Grid container spacing={1.5} sx={{ m: 1.5, mt: 2 }}>
        <Grid size={12}>
            <BusinessPipelineTable
                rows={BusinessPipelineMock}
                isFetching={false}
                isError={false}
                asOnDate="2026-02-20"
            />
        </Grid>
      </Grid>
    </>
  );
};

export default BusinessSummary;
